import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/attendance-engine/_layout/logic-components/$componentId/_layout/attendance-units/')({});